export default __webpack_public_path__ + "static/media/logout_icon.3775d5f6.svg";